import React, { useEffect, useState, useMemo } from "react";
import { Button, ModalBody, ModalFooter, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown, Input, FormGroup, Modal, Label, ModalHeader } from "reactstrap";
import { Trans } from "react-i18next";
import useModal from "hooks/useModal";
import { NotificationManager } from "react-notifications";
import Edit from "../Columns/Edit";
import { useBaseModal } from "services";
import {
  useForm
} from "react-hook-form";
import { Control, LocalForm } from "react-redux-form";


const   List = ({
  t,
  getListColumns,
  listColumns,
  options,
  client,
  list_id,
  stageRows,
  setFilteredStageRows,
}) => {

  const [searchQuery, setSearchQuery] = useState('');

  const [selectedColumnId, setSelectedColumnId] = useState(null);
  const [selectedColumnFilterBy, setSelectedColumnFilterBy] = useState({});
  const [selectedOption, setSelectedOption] = useState('text');
  const [isRequired, setIsRequired] = useState(false);
  const [filterByModal, setFilterByModal] = useState(false);
  const [columnValues, setColumnValues] = useState([]);
  const [checkedValues, setCheckedValues] = useState({});

  const [SetCreateUpdateColumnSecondModal, CreateUpdateColumnSecondToggle, CreateUpdateColumnSecondModal] = useBaseModal();
  const filterByToggleModal = () => setFilterByModal(!filterByModal);
  const [SetCreateColumnModal, CreateColumnToggle, CreateColumnModal] = useBaseModal();
  const { Modal: DeleteModal, toggle: deleteToggle, isOpen: isDeleteOpen } = useModal();

  const namesArray = useMemo(() => listColumns.map(column => column.name.toLowerCase()), [listColumns]);

  const defaultColumnChoices = useMemo(() => [
    { id: 1, name: "Choice 1" },
    { id: 2, name: "Choice 2" },
    { id: 3, name: "Choice 3" },
  ], []);

  const methods = useForm({
    mode: "onBlur",
    defaultValues: {
      column_choices: defaultColumnChoices
    },
  });

  const { reset, control, handleSubmit, watch, getValues, setValue } = methods;

  useEffect(() => {
    changeType(selectedOption);
  }, [selectedOption, reset]);

  const changeType = (selectedOption) => {
    if (selectedOption !== "choice") {
      reset({ column_choices: [] });

      setSelectedOption(selectedOption);
    } else {
      reset({
        column_choices: defaultColumnChoices,
      });
    }
  };

  const editColumn = (columnId) => {
    setSelectedColumnId(columnId);
    SetCreateUpdateColumnSecondModal(true);
  };

  useEffect(() => {
    const savedFilters = JSON.parse(localStorage.getItem("activeFilters"));
    const savedCheckedValues = JSON.parse(localStorage.getItem("checkedValues")) || {};
    setCheckedValues(savedCheckedValues);
    if (savedFilters) {
      applySavedFilters(savedFilters);
    }
  }, []);

  const applyFiltersUrl = async (list_id, column_id, payload) => {
    try {
      const resp = await client.post(
        `list-details/${list_id}/pipeline-stage/${column_id}/rows_filter_by`,
        payload
      )

      return resp?.data;
    } catch (error) {
      console.error("Failed to apply filters:", error);
    }
  }

  const applyFilter = async (data) => {
    const choices_ids = Object.keys(data).filter(key => data[key]);
    const updatedPayload = {
      column_value: choices_ids,
      column_id: selectedColumnFilterBy?.id
    };
    const response = await applyFiltersUrl(list_id, selectedColumnFilterBy?.id, updatedPayload);
    setFilteredStageRows(response);
    filterByToggleModal();

    localStorage.setItem("activeFilters", JSON.stringify(updatedPayload));
  };

  const applySavedFilters = async (savedFilters) => {
    const response = await applyFiltersUrl(list_id, savedFilters?.column_id, savedFilters);
    setFilteredStageRows(response);
  };

  const clickFilterBy = (column) => {
    setSelectedColumnFilterBy(column);
    filterByToggleModal(true);
    displayColumnValues(column);
  };

  const handleDeleteColumnModal = (columnId) => {
    setSelectedColumnId(columnId);
    deleteToggle()
  };

  const handleModalClose = () => {
    CreateUpdateColumnSecondToggle(false);
  };

  const handleDeleteColumn = async () => {

    try {
      const response = await client.delete(
        `list-details/${list_id}/tracking-list-column/${selectedColumnId}`
      );
      getListColumns();
      NotificationManager.success(t("Column deleted successfully"));
    } catch (error) {
      NotificationManager.error(error.response.data.error || t("Something went wrong"));
    };
    deleteToggle();
  };

  const columnId = selectedColumnId || selectedColumnFilterBy?.id;
  const column_obj = useMemo(() => listColumns.find(column => column.id === columnId), [listColumns, columnId]);

  const rowValues = (item) => {
    const choice = column_obj?.column_choices?.find((choice) =>
      String(choice?.column) === String(columnId) &&
      String(choice?.id) === String(item)
    );
    return choice?.name || item;
  };

  const displayColumnValues = (column) => {
    if (!column?.id) return;
    const values = stageRows.flatMap(stage =>
      stage.list_stage_rows.flatMap(row => {
        return row.cell_mapping[column?.id]?.column_value || [];
      })
    );

    const uniqueValues = Array.from(new Set(values));
    setColumnValues(uniqueValues);
    const savedCheckedValues = JSON.parse(localStorage.getItem("checkedValues")) || {};
    const initialCheckedValues = uniqueValues.reduce((acc, value) => {
      acc[value] = savedCheckedValues[column.id]?.[value] || false;
      return acc;
    }, {});
    setCheckedValues(initialCheckedValues);
  };

  const onClear = () => {
    localStorage.removeItem("activeFilters");
    localStorage.removeItem("checkedValues");
    filterByToggleModal();
    setFilteredStageRows(stageRows);
  };

  const handleCheckboxChange = (item) => {
    setCheckedValues(prevState => {
      const newState = {
        ...prevState,
        [item]: !prevState[item]
      };
      const updatedCheckedValues = {
        ...JSON.parse(localStorage.getItem("checkedValues")) || {},
        [columnId]: newState
      };
      localStorage.setItem("checkedValues", JSON.stringify(updatedCheckedValues));
      return newState;
    });
  };

  const getFilteredColumnValues = () => {
    return columnValues?.filter((item) => {
      const displayValue = String(rowValues(item));
      return displayValue.toLowerCase().includes(searchQuery.toLowerCase());
    }) || [];
  };

  return (
    <>
      {listColumns?.length > 0 && listColumns?.map((item, index) => (
        <th key={index} className="bg-white text-left text-nowrap">
          <div className="d-flex justify-content-start align-items-center mr-2" style={{ maxWidth: "120px" }}>
            <UncontrolledDropdown
              direction="down"
            >
              <DropdownToggle
                color="text-white"
                className="bg-white no-shadow mx-0 px-0"
              >
                {item?.name}
                <i className="fa fa-angle-down ml-2" ></i>
              </DropdownToggle>
              <DropdownMenu className="p-0">
                <DropdownItem onClick={() => editColumn(item?.id)}>
                  <Trans>Edit</Trans>
                </DropdownItem>
                <DropdownItem onClick={() => clickFilterBy(item)}>
                  <Trans>Filter by</Trans>
                </DropdownItem>
                <DropdownItem onClick={() => handleDeleteColumnModal(item?.id)}>
                  <Trans>Delete</Trans>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </th>
      ))}
      <div className="clickable bg-white float-right mt-3 mx-4" onClick={() => { setSelectedColumnId(""); SetCreateColumnModal(true) }}>
        <i className="fa fa-plus text-success mr-2"></i>
        <Trans>Add column</Trans>
      </div>

      <Edit
        setSelectedOption={setSelectedOption}
        options={options}
        item={column_obj}
        control={control}
        reset={reset}
        namesArray={namesArray}
        defaultColumnChoices={defaultColumnChoices}
        setIsRequired={setIsRequired}
        isRequired={isRequired}
        CreateUpdateColumnSecondModal={CreateUpdateColumnSecondModal}
        SetCreateUpdateColumnSecondModal={SetCreateUpdateColumnSecondModal}
        CreateColumnModal={CreateColumnModal}
        SetCreateColumnModal={SetCreateColumnModal}
        handleModalClose={handleModalClose}
        selectedOption={selectedOption}
        selectedColID={selectedColumnId}
        list_id={list_id}
        getValues={getValues}
        getListColumns={getListColumns}
        CreateUpdateColumnSecondToggle={CreateUpdateColumnSecondToggle}
        client={client}
        t={t}
      />

      {isDeleteOpen && (
        <DeleteModal>
          <ModalBody>
            <Trans>Are you sure you want to delete this column?</Trans>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={handleDeleteColumn}>
              <Trans>Yes</Trans>
            </Button>
            <Button color="secondary" onClick={deleteToggle}>
              <Trans>No</Trans>
            </Button>
          </ModalFooter>
        </DeleteModal>
      )}

      <Modal
        isOpen={filterByModal}
        toggle={filterByToggleModal}
        className="right_modal"
      >
        <ModalHeader toggle={filterByToggleModal}>
          <Label className="text-dark">
            <Trans>Filter by </Trans> {selectedColumnFilterBy?.name}
          </Label>
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </FormGroup>
          <LocalForm
            onSubmit={(values) => applyFilter(values)}
          >
            <div className="options my-3">
              {getFilteredColumnValues()?.length > 0 && getFilteredColumnValues()?.map((item, index) => (
                <FormGroup check key={index} className="p-0 my-2">
                  <div className="d-flex justify-content-start align-items-start ml-0">
                    <div className="mr-2">
                      <Control.checkbox
                        model={`.${item}`}
                        checked={checkedValues[item]}
                        defaultValue={checkedValues[item]}
                        onChange={() => handleCheckboxChange(item)}
                      />
                    </div>
                    <div>
                      <Label check for={item}>
                        {rowValues(item)}
                      </Label>
                    </div>
                  </div>
                </FormGroup>
              ))}
            </div>
            <div className="mt-2">
              <Button type="submit" color="primary" className="ml-0">
                <Trans>Apply</Trans>
              </Button>
              <Button color="secondary" onClick={onClear}>
                <Trans>Clear filters</Trans>
              </Button>
            </div>
          </LocalForm>
        </ModalBody>
      </Modal>
    </>
  );
};

export default List;
